// Firebase web config. CommonJS rather than an ES module export so the
// maintenance scripts in ../../scripts (plain Node, no build step) can
// require the same values the app uses instead of keeping a second copy that
// silently drifts. These are public client identifiers, not secrets — access
// is controlled by Firestore rules.
module.exports = {
  apiKey: "AIzaSyAXDRYV_c6zKlhnmZSYCu9i0eBhNDJfo94",
  authDomain: "alg-frontend.firebaseapp.com",
  projectId: "alg-frontend",
  storageBucket: "alg-frontend.appspot.com",
  messagingSenderId: "727083865163",
  appId: "1:727083865163:web:ac807ede63fd56689e29ce",
  measurementId: "G-J59TH8LBYT",
};
